import type React from "react";

import type { IOts } from "@ps-bridge/interop";
import type { Ok } from "@ps-bridge/ok";
import { runIO } from "@view/effects/effectRunner";

type InputChangeEvent = React.ChangeEvent<HTMLInputElement>;

export const onInputAction = (handler: (value: string) => IOts<Ok>) =>
  (event: InputChangeEvent): Ok =>
    runIO(handler(event.target.value));
